import type { AvatarProps } from "./Avatar";

/** Shared avatar size token for module top-bar headers. */
export const TOPBAR_AVATAR_SIZE: AvatarProps["size"] = "sm";
